<ng-container *ngIf="isVisible$ | async">
  <app-push-shop-card-v2-atom
    [entity]="entity"
    [title]="entityName ? entityName : entity[entityKeys.Name]"
    [category]="entityCategory ? entityCategory : entity[entityKeys.Type][entityKeys.Name]"
    [shortDescription]="entity[entityKeys.ShortDescription]"
    [imgUrl]="image ? image.url : shopImage"
    [linkUrl]="entitiesService.getUrl(entity)"
    [displayEntityImage]="displayEntityImage"
    [displayEntityDistance]="displayEntityDistance"
    [displayEntityPricing]="displayEntityPricing"
    [displayEntityAddress]="displayEntityAddress"
    [displayEntityCategory]="displayEntityCategory"
    [entityNameSize]="entityNameSize"
    [kioskCardAspectRatio]="kioskCardAspectRatio"
    [templateLayout]="templateLayout"
  ></app-push-shop-card-v2-atom>
</ng-container>
